import { GetGarmentItemsViewParams, RoamingItemsPayload } from "domain/RoamingItems";
import { httpApi } from "./http.api"
import moment from "moment";
import { AxiosResponse } from "axios";

export const getGarmentItemsView = async ({
  count = true,
  top = 10,
  skip = 0,
  filter = "",
}: GetGarmentItemsViewParams) => {
  const filterQuery = filter ? `&$filter=${encodeURIComponent(filter)}` : "";
  return httpApi
    .get(
      `GarmentItemsView/GetGarmentItems?$count=${count}&$top=${top}&$skip=${skip}${filterQuery}`
    )
    .then(({ data }) => {
      return data;
    });
};

export const getRoamingItemsPopup = ({
  count = true,
  top = 10,
  skip = 0,
  filter = "",
}: GetGarmentItemsViewParams) => {
  const filterQuery = filter ? `&$filter=${encodeURIComponent(filter)}` : "";
  return httpApi
    .get(
      `RoamingItemsPopupView/GetRoamingItemsPopup?$count=${count}&$top=${top}&$skip=${skip}${filterQuery}`
    )
    .then(({ data }) => {
      return data;
    });
};


export const addRoamingItem = async (roamingPayload: any) => {
  return httpApi
    .post<any>(`RoamingItems/AddRoamingItem`, {
      ...roamingPayload,
    })
    .then(({ data }) => {
      return data
    })
}

export const updateRoamingItems = async (roamingPayload: RoamingItemsPayload) => {
  return httpApi
    .put<RoamingItemsPayload>(`RoamingItems/UpdateRoamingItems`, roamingPayload)
    .then(({ data }) => {
      return data
    })
}

export const readRFID = async (roamingItemId: string) => {
  return httpApi
      .post(`RfidReader/NewBatch/${roamingItemId}`)
      .then(({ data }) => {
          return data
      })
}

export const deleteRoamingItem = async (id: number): Promise<any> => {
  let time = moment().toISOString();
  let hmac_token: AxiosResponse<any> = await httpApi.delete<any>(
    `RoamingItems/${id}/DeleteRoamingItem/`,
    {
      data: { hmac_time: time },
    }
  );

  return httpApi.delete<any>(`RoamingItems/${id}/DeleteRoamingItem/`, {
    data: { hmac_time: time, hmac: hmac_token?.data?.hmac },
  });
};

export const getGarmentItemsClientView = ({
  count = true,
  top = 10,
  skip = 0,
  filter = "",
}: any) => {
  const filterQuery = filter ? `&$filter=${encodeURIComponent(filter)}` : "";
  return httpApi
    .get(
      `GarmentItemsClientsView/GetGarmentItemsClients?$count=${count}&$top=${top}&$skip=${skip}${filterQuery}`
    )
    .then(({ data }) => {
      return data;
    });
};